import { kea } from 'kea'
import PropTypes from "prop-types";
import { filter } from 'lodash'

import { selector as configSelector } from '~/config'
import entities from '~/entities'

import rootLogic from '~/scenes/logic'
import {STATE_CONTENTS, STATE_HIDDEN, STATE_ORDERED} from "~/constants/cart";

const ignoredSteps = [STATE_ORDERED, STATE_HIDDEN, STATE_CONTENTS];

export default kea({
  path: () => ['scenes', 'checkout'],
  connect: {
    actions: [
      rootLogic, [
        'navigate',
        'closeCart'
      ]
    ],
    values: [
      rootLogic, [
        'previousStep',
        'cartItemsCount',
        'availableSteps',
        'loading',
        'retrying'
      ]
    ]
  },
  selectors: ({ constants, selectors }) => ({
    currentStep: [
      () => [
        entities.selectors.activeCart
      ], (activeCart) => {
        if(activeCart) {
          return activeCart.current_state;
        }

        return null;
      },
      PropTypes.string
    ],
    hideCheckout: [
      () => [
        selectors.previousStep
      ], (previousStep) => {
        if(previousStep) {
          return previousStep.to === STATE_CONTENTS;
        }

        return false;
      },
      PropTypes.bool
    ],
    activeCart: [
      () => [
        entities.selectors.activeCart,
      ], (activeCart) => {
        return activeCart
      },
      PropTypes.object
    ],
    activeShop: [
      () => [
        entities.selectors.activeShop,
      ], (activeShop) => {
        return activeShop
      },
      PropTypes.object
    ],
    steps: [
      () => [
        entities.selectors.activeCart,
      ], (activeCart) => {
        if(activeCart) {
          const { routes } = activeCart;

          return filter(routes, (route) => {
            return ignoredSteps.indexOf(route.to) === -1
          });
        }
      },
      PropTypes.array
    ],
  }),
})
